export default "__VITE_ASSET__Zb5y302I__"